import { render, staticRenderFns } from "./BaseIconClickable.vue?vue&type=template&id=0d74fd2c&scoped=true"
import script from "./BaseIconClickable.vue?vue&type=script&lang=js"
export * from "./BaseIconClickable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d74fd2c",
  null
  
)

export default component.exports